import { RouterLink } from "@/components/ui/router-link"
import { Button, Container, Text } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

const ErrorView = () => {
  const { t } = useTranslation("common")
  return (
    <>
      <Container
        h="100vh"
        alignItems="stretch"
        justifyContent="center"
        textAlign="center"
        maxW="sm"
        centerContent
      >
        <Text fontSize="8xl" fontWeight="bold" lineHeight="1" mb={4}>
          500
        </Text>
        <Text fontSize="md">{t("error.oops")}</Text>
        <Text fontSize="md">{t("error.somethingWrong")}</Text>
        <RouterLink to="/" asChild>
          <Button variant="outline" mt={4} asChild>
            {t("error.goBack")}
          </Button>
        </RouterLink>
      </Container>
    </>
  )
}

export default ErrorView
